import location from '../components/address'

export default {
  location
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/index/resources/components.js